import { ActionTypes } from '../actionTypes'
import { ContactsLost, ContactsLostActionTypes } from './types'

const initialState: ContactsLost = {
  lostTime: new Date(),
  storeName: '',
  lostPlace: '',
  lostType: '',
  lostOfPurchase: {
    hasReceipt: '',
    hasReceiptYes: {
      regiNumber: '',
      receiptNumber: '',
    },
    hasReceiptNo: {
      cardNumber: '',
    },
    lostItemsName: '',
    lostItemsDetail: '',
  },
  lostOfPersonal: {
    lostItemsName: '',
    lostItemsDetail: '',
  },
  lostOfPrepaidCard: {
    cardNumber: '',
    registeredPhoneNumber: '',
    birthday: '',
    registeredAddress: {
      zipCode: '',
      formattedZipCode: '',
      address: '',
    },
  },
  nameKanji: {
    sei: '',
    mei: '',
  },
  nameKana: {
    sei: '',
    mei: '',
  },
  phoneNumber: '',
  mail: '',
}

export const ContactsLostReducer = (
  state = initialState,
  action: ContactsLostActionTypes
): ContactsLost => {
  switch (action.type) {
    case ActionTypes.contactsLost:
      return {
        ...state,
        lostTime: action.payload.lostTime,
        storeName: action.payload.storeName,
        lostPlace: action.payload.lostPlace,
        lostType: action.payload.lostType,
        lostOfPurchase: {
          hasReceipt: action.payload.lostOfPurchase
            ? action.payload.lostOfPurchase.hasReceipt
            : '',
          hasReceiptYes: {
            regiNumber:
              action.payload.lostOfPurchase?.hasReceiptYes?.regiNumber,
            receiptNumber:
              action.payload.lostOfPurchase?.hasReceiptYes?.receiptNumber,
          },
          hasReceiptNo: {
            cardNumber: action.payload.lostOfPurchase?.hasReceiptNo?.cardNumber,
          },
          lostItemsName: action.payload.lostOfPurchase
            ? action.payload.lostOfPurchase.lostItemsName
            : '',
          lostItemsDetail: action.payload.lostOfPurchase
            ? action.payload.lostOfPurchase.lostItemsDetail
            : '',
        },
        lostOfPersonal: {
          lostItemsName: action.payload.lostOfPersonal
            ? action.payload.lostOfPersonal.lostItemsName
            : '',
          lostItemsDetail: action.payload.lostOfPersonal
            ? action.payload.lostOfPersonal.lostItemsDetail
            : '',
        },
        lostOfPrepaidCard: {
          cardNumber: action.payload.lostOfPrepaidCard?.cardNumber,
          registeredPhoneNumber: action.payload.lostOfPrepaidCard
            ? action.payload.lostOfPrepaidCard.registeredPhoneNumber
            : '',
          birthday: action.payload.lostOfPrepaidCard
            ? action.payload.lostOfPrepaidCard.birthday
            : '',
          registeredAddress: {
            zipCode:
              action.payload.lostOfPrepaidCard?.registeredAddress?.zipCode,
            formattedZipCode:
              action.payload.lostOfPrepaidCard?.registeredAddress
                ?.formattedZipCode,
            address:
              action.payload.lostOfPrepaidCard?.registeredAddress?.address,
          },
        },
        nameKanji: action.payload.nameKanji,
        nameKana: action.payload.nameKana,
        phoneNumber: action.payload.phoneNumber,
        mail: action.payload.mail,
      }
    case ActionTypes.clearState:
      return (state = initialState)
    default:
      return state
  }
}
